import dynamic from 'next/dynamic';
import { Search } from 'lucide-react';

const GeneralSearch = dynamic(() =>
  import('@mais-retorno-front/components/general-search').then(
    (mod) => mod.GeneralSearch
  )
);

const HomeLayout = dynamic(() => import('@mais-retorno-front/layouts/home'));

const Custom404 = () => {
  return (
    <HomeLayout>
      <div className="min-h-[65vh] flex justify-between items-center">
        <div className="container m-auto px-4 py-8 sm:py-12 space-y-14">
          {/* Hero Section */}
          <div className="text-center">
            <p className="text-gray-900 text-6xl font-semibold">404</p>
            <h1 className="text-xl sm:text-3xl lg:text-4xl font-medium text-gray-900">
              Página não encontrada
            </h1>
            <p className="text-base sm:text-lg text-gray-600 mb-4 max-w-xl mx-auto leading-relaxed">
              A página que você está procurando não existe ou foi movida
            </p>
          </div>

          {/* Search Section */}
          <div className="max-w-3xl mx-auto ">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl mb-3">
                <Search size={20} className="text-blue-700" />
              </div>
              <p className="text-sm text-gray-600 max-w-lg mx-auto">
                Busque por fundos de investimento, ações, ETFs e muito mais.
              </p>
            </div>

            <GeneralSearch />
          </div>
        </div>
      </div>
    </HomeLayout>
  );
};

export default Custom404;
